module.exports = __webpack_public_path__ + "img/10.22c2fa68.jpg";